import Footer from './Footer';
import withNavigationTheme from '../hooks/withNavigationTheme';

/**
 * @deprecated Use `PublicFooter` or `PrivateFooter` instead
 */
export default withNavigationTheme(Footer);
